import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100"
}
const _hoisted_2 = {
  key: 0,
  class: "ofh w14 fl navBarReturn whiteColor",
  style: {"background":"#111"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "ofh fl navBarTitle"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "fs13 whiteColor" }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "fs12 fw400 arial"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarThumbnailContent = _resolveComponent("CalendarThumbnailContent")!
  const _component_AlertBadge = _resolveComponent("AlertBadge")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.rcm && _ctx.rcm.room)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("section", {
          class: "ofh kakugo w100 posFi shadowContent messageHeader skyblueBg",
          style: _normalizeStyle({
                top: 0,
                zIndex: 10,
                borderBottom: _ctx.rcm.edittingAstag ? `0` : ``,
            })
        }, [
          (_ctx.href && !_ctx.href.includes(`/start`) && _ctx.showBackButton && !_ctx.rcm.edittingAstag)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickBack && _ctx.clickBack(...args)))
                }, [
                  _createElementVNode("p", {
                    class: _normalizeClass(`kakugo pointer ml20 ${_ctx.isSP ? 'fs13' : 'ls1 fs13'}`),
                    style: {"line-height":"68px"}
                  }, [
                    _createElementVNode("span", null, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/leftArrow_lgrey.png`),
                        width: "15",
                        height: "19",
                        style: {"margin-top":"-4px"}
                      }, null, 8, _hoisted_3),
                      (!_ctx.isSP)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "戻る"))
                        : _createCommentVNode("", true)
                    ])
                  ], 2)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.rcm.edittingAstag)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/logo/waaqLink_logo_white_flat.gif`),
                  class: "serviceLogo fl",
                  style: _normalizeStyle({
                        width: `130px`,
                        marginLeft: _ctx.isSP ? `10px` : `30px`,
                        marginTop: _ctx.isSP ? `10px` : `8px`,
                    })
                }, null, 12, _hoisted_6),
                (_ctx.isSP)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _hoisted_9))
                  : _createCommentVNode("", true),
                _createElementVNode("h4", {
                  class: _normalizeClass(`kakugo fl ${_ctx.isSP ? 'fs14' : 'ls1 fs14'}`),
                  style: _normalizeStyle({
                        marginLeft: _ctx.isSP ? `10px` : `30px`,
                        marginTop: _ctx.isSP ? `` : `8px`,
                        marginRight: _ctx.isSP ? `` : `18px`,
                        color: `#fafafa`,
                    })
                }, [
                  (!_ctx.isSP)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, "|  "))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: "fw600",
                    style: _normalizeStyle({
                            marginLeft: _ctx.isSP ? `2px` : ``,
                        })
                  }, _toDisplayString(_ctx.pageTitle), 5)
                ], 6),
                (_ctx.buttonTitle && !_ctx.isSuspend)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "submit",
                      class: _normalizeClass(`circle_button pinkBg fffColor fr centered fw600 ${_ctx.enabledSave ? `` : `disabled`}`),
                      style: _normalizeStyle(
                        _ctx.isSP
                            ? {
                                  position: `absolute`,
                                  right: `5px`,
                                  top: `12px`,
                                  padding: `6px 12px`,
                                  border: `1px solid #3c3f98`,
                              }
                            : {
                                  minWidth: `140px`,
                                  marginRight: `20px`,
                                  padding: `6px 12px`,
                                  border: `1px solid #3c3f98`,
                              }
                    ),
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickPinkButton && _ctx.clickPinkButton(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.buttonTitle), 1)
                    ], 6))
                  : _createCommentVNode("", true),
                (_ctx.showDraftButton)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 2,
                      class: "whiteColor fr fw600 mt8 mr15 fs14 pointer",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveDraft && _ctx.saveDraft(...args)))
                    }, " 下書きとして保存 "))
                  : _createCommentVNode("", true),
                false
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 3,
                      class: "whiteColor fr fw600 mt8 mr15 fs14 pointer",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showRoomPreview && _ctx.showRoomPreview(...args)))
                    }, "プレビュー"))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_CalendarThumbnailContent, {
                  style: {"margin-left":"20px"},
                  clickChangeName: _ctx.clickChangeName,
                  clickChangeAutoMode: _ctx.clickChangeAutoMode
                }, null, 8, ["clickChangeName", "clickChangeAutoMode"])
              ])),
          _hoisted_13
        ], 4),
        (_ctx.rcm.edittingAstag)
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              class: "posFi w100 blackBg whiteColor centered fw600",
              style: _normalizeStyle({
                top: _ctx.isSP ? `60px` : `68px`,
                height: `40px`,

                boxShadow: `10px 5px 17px #ddd`,
                zIndex: 2,
            })
            }, [
              _createElementVNode("div", {
                class: "fl mt10 ml20 pointer",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickEditTimeSpan && _ctx.clickEditTimeSpan(...args)))
              }, [
                _createTextVNode(" 調整可能時間・期間の設定"),
                (_ctx.Util.isPresent(_ctx.periodText))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, "（" + _toDisplayString(_ctx.periodText) + "）", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "rad16 whiteColor fw600 fr mt4 mr20 borderWhite l2 pointer hoverGreyBg",
                style: {"padding":"5px 14px"},
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editEndAstag(true)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/calendar_white.png`),
                  width: "18",
                  height: "18",
                  style: {"margin-top":"-3px"}
                }, null, 8, _hoisted_15),
                _createTextVNode("  調整カレンダーの変更を保存して終了 ")
              ]),
              _createElementVNode("div", {
                class: "fr mr20 mt13 fs12 pointer hoverGrey",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editEndAstag(false)))
              }, "変更をキャンセル"),
              _hoisted_16
            ], 4))
          : (_openBlock(), _createElementBlock("section", {
              key: 1,
              class: "posFi w100 with_white_bg centered fw600",
              style: _normalizeStyle({
                top: _ctx.isSP ? `60px` : `68px`,
                height: `40px`,
                lineHeight: `40px`,
                boxShadow: `10px 5px 17px #ddd`,
                zIndex: 2,
                display: `flex`,
                justifyContent: `center`,
            })
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(`settingsCategoryTab fl pointer ${_ctx.selectedTabName == `room` ? `selected` : ``}`),
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.showRoom && _ctx.showRoom(...args)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/pageicon.png`),
                  width: "13",
                  height: "13",
                  style: {"margin-top":"-2px"}
                }, null, 8, _hoisted_17),
                _createTextVNode("   調整ページ "),
                (_ctx.showAlertBudge())
                  ? _withDirectives((_openBlock(), _createBlock(_component_AlertBadge, {
                      key: 0,
                      num: 1,
                      display: `nonum`,
                      class: "fr posRe ml5 mt5",
                      style: {},
                      onClick: _ctx.clickBudge
                    }, null, 8, ["onClick"])), [
                      [_directive_tooltip, `限定公開ページの場合、出席者は必須項目です。`]
                    ])
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(`settingsCategoryTab fl pointer ${_ctx.selectedTabName == `mail` ? `selected` : ``}`),
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showMailPreview && _ctx.showMailPreview(...args)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/home/mail_icon.png`),
                  width: "14",
                  height: "14",
                  style: {"margin-top":"-3px"}
                }, null, 8, _hoisted_18),
                _createTextVNode("  メール ")
              ], 2),
              (_ctx.rcm.room.room_type == `parent_room`)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(`settingsCategoryTab fl pointer ${_ctx.selectedTabName == `settings` ? `selected` : ``}`),
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showParentRoomSettings && _ctx.showParentRoomSettings(...args)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/user_settings.png`),
                      width: "14",
                      height: "14",
                      style: {"margin-top":"-3px"}
                    }, null, 8, _hoisted_19),
                    _createTextVNode("  限定公開設定 ")
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.rcm.room.room_type == `public_room`)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(`settingsCategoryTab fl pointer ${_ctx.selectedTabName == `form` ? `selected` : ``}`),
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showFormPreview && _ctx.showFormPreview(...args)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/form_icon.png`),
                      width: "14",
                      height: "14",
                      style: {"margin-top":"-3px"}
                    }, null, 8, _hoisted_20),
                    _createTextVNode("  フォーム ")
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.rcm.room.room_type == `public_room`)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass(`settingsCategoryTab fl pointer ${_ctx.selectedTabName == `settings` ? `selected` : ``}`),
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.showPublicRoomSettings && _ctx.showPublicRoomSettings(...args)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/user_settings.png`),
                      width: "14",
                      height: "14",
                      style: {"margin-top":"-3px"}
                    }, null, 8, _hoisted_21),
                    _createTextVNode("  その他設定 ")
                  ], 2))
                : _createCommentVNode("", true)
            ], 4)),
        (false && _ctx.rcm.room.room_type == `public_room` && _ctx.selectedTabName == `form`)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "w100 llgreyBg posFi",
              style: _normalizeStyle({ zIndex: 2, display: `flex`, justifyContent: `center`, height: `40px`, top: _ctx.isSP ? `100px` : `108px` })
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(`fs12 mt2 fl pointer pad10 ml20 ${_ctx.selectedFormTabName == `commonForm` ? `fw600 selected` : ``}`),
                style: {"width":"180px"},
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectSmallCategory(`commonForm`)))
              }, " 共通フォーム ", 2),
              _createElementVNode("div", {
                class: _normalizeClass(`fs12 mt2 fl pointer pad10 ${_ctx.selectedFormTabName == `assignForm` ? `fw600 selected` : ``}`),
                style: {"width":"180px"},
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectSmallCategory(`assignForm`)))
              }, " 振り分けフォーム ", 2),
              _hoisted_22
            ], 4))
          : _createCommentVNode("", true),
        _hoisted_23
      ]))
    : _createCommentVNode("", true)
}